// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import ClaimForApprovalPricingSummary from '@deere/cps-it.warranty-model-factory/lib/claim-for-approval-pricing-summary';
import {FormattedMessage} from 'react-intl';
import {buildCurrency} from '../../../shared/services/build-number';

const PricingSummary = props =>
    <section className='pricing-summary'>
        <ul className='column-headers'>
            <li>
                <header>
                    <FormattedMessage id='PRICING_SUMMARY'/>
                </header>
            </li>
            <li>
                <FormattedMessage id='PARTS'/>
            </li>
            <li>
                <FormattedMessage id='LABOR'/>
            </li>
            <li>
                <FormattedMessage id='OTHER_CREDITS'/>
            </li>
            <li className='total'>
                <FormattedMessage id='TOTAL'/>
            </li>
        </ul>
        <section className='data'>
            <ul className='net-values'>
                <li>
                    <FormattedMessage id='NET'/>
                </li>
                <li>
                    {buildCurrency(props.net.parts)}
                </li>
                <li>
                    {buildCurrency(props.net.labor)}
                </li>
                <li>
                    {buildCurrency(props.net.otherCredits)}
                </li>
                <li className='total'>
                    {buildCurrency(props.net.total)}
                </li>
            </ul>
            <ul className='list-values'>
                <li>
                    <FormattedMessage id='LIST'/>
                </li>
                <li>
                    {buildCurrency(props.list.parts)}
                </li>
                <li>
                    {buildCurrency(props.list.labor)}
                </li>
                <li>
                    {buildCurrency(props.list.otherCredits)}
                </li>
                <li className='total'>
                    {buildCurrency(props.list.total)}
                </li>
            </ul>
        </section>
    </section>;

PricingSummary.displayName = 'PricingSummary';
PricingSummary.propTypes = {
    list: PropTypes.instanceOf(ClaimForApprovalPricingSummary).isRequired,
    net: PropTypes.instanceOf(ClaimForApprovalPricingSummary).isRequired
};

export default PricingSummary;



// WEBPACK FOOTER //
// ./src/tabm/spa-details/components/pricing-summary.js